const MODULE_PREFETCH_MAP: Record<string, () => Promise<unknown>> = {
  map: () => import("../../../map/map.module"),
  parcels: () => import("../../parcels/ParcelsModule"),
  "precision-farming": () =>
    import("../../../precision-farming/PrecisionFarmingModule"),
  telematics: () => import("../../../telematics/TelematicsModule"),
  sensors: () => import("../../../sensors/SensorsModule"),
  irrigation: () => import("../../../irrigation/IrrigationModule"),
  notifications: () => import("../../../notifications/NotificationsModule"),
  actions: () => import("../../../evidence/actions/ActionsModule"),
  "actions-v2": () => import("../../../evidence/actions-v2/ActionsV2Module"),
  stores: () => import("../../../evidence/stores/StoresModule"),
  reports: () => import("../../../evidence/reports/ReportsModule"),
  catalogues: () => import("../../../catalogues/containers/CataloguesModule"),
  admin: () => import("../../../admin/AdminModule"),
};

const prefetchedModules = new Set<string>();

const prefetchModule = (route: string): void => {
  if (isPrefetched(route)) {
    return;
  }

  const prefetchFn = MODULE_PREFETCH_MAP[route];
  if (prefetchFn) {
    prefetchedModules.add(route);
    prefetchFn().catch(() => {
      prefetchedModules.delete(route);
    });
  }
};

const isPrefetched = (route: string): boolean => prefetchedModules.has(route);

export { prefetchModule };
